import { configureStore } from "@reduxjs/toolkit"
import userWithGoogle from "./userWithGoogle/actions"
import adminUser from "./adminUserLogin/actions"
import ChatState from "./chatStates/actions"
import PublicCurrentPages from "./PublicCurrentPage/actions"


const AppReducers = {
    userWithGoogle,
    adminUser,
    ChatState,
    PublicCurrentPages
}

const store = configureStore({
    reducer: AppReducers,
    devTools: false
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
